var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref, watch } from "vue";
import { BAlert, BButton, BFormCheckbox, BModal } from "bootstrap-vue";
import { exportToFileSource, getExportRecords } from "@/components/History/Export/services";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ExportToFileSourceForm from "@/components/Common/ExportForm.vue";
import { DEFAULT_EXPORT_PARAMS } from "@/composables/shortTermStorage";
import { useTaskMonitor } from "@/composables/taskMonitor";
import ExportRecordCard from "./ExportRecordCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryArchiveExportSelector',
    props: {
        history: null
    },
    emits: ["onArchive"],
    setup(__props, { emit }) {
        const props = __props;
        const { isRunning: isExportTaskRunning, waitForTask, requestHasFailed: taskMonitorRequestFailed, hasFailed: taskHasFailed, } = useTaskMonitor();
        const existingExports = ref([]);
        const isLoading = ref(true);
        const isExportingRecord = ref(false);
        const isExportDialogOpen = ref(false);
        const isDeleteContentsConfirmed = ref(false);
        const exportErrorMessage = ref(null);
        const mostUpToDateExport = computed(() => {
            return existingExports.value.find((exportRecord) => exportRecord.isPermanent && (exportRecord.isUpToDate || exportRecord.isPreparing));
        });
        const canCreateExportRecord = computed(() => {
            return !isLoading.value && !isExportTaskRunning.value && !mostUpToDateExport.value;
        });
        const canArchiveHistory = computed(() => {
            return (!isLoading.value && !isExportTaskRunning.value && mostUpToDateExport.value && isDeleteContentsConfirmed.value);
        });
        const mostUpToDateExportIsReady = computed(() => {
            return mostUpToDateExport.value && mostUpToDateExport.value.isReady && mostUpToDateExport.value.canReimport;
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            isLoading.value = true;
            yield updateExports();
            isLoading.value = false;
        }));
        watch(isExportTaskRunning, (newValue, oldValue) => {
            isExportingRecord.value = newValue;
            const hasFinished = oldValue && !newValue;
            if (hasFinished) {
                updateExports();
            }
        });
        function updateExports() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                exportErrorMessage.value = null;
                try {
                    existingExports.value = yield getExportRecords(props.history.id);
                    if (mostUpToDateExport.value) {
                        const shouldWaitForTask = ((_a = mostUpToDateExport.value) === null || _a === void 0 ? void 0 : _a.isPreparing) &&
                            !isExportTaskRunning.value &&
                            !taskMonitorRequestFailed.value &&
                            !taskHasFailed.value;
                        if (shouldWaitForTask) {
                            waitForTask(mostUpToDateExport.value.taskUUID);
                        }
                        if (taskMonitorRequestFailed.value) {
                            exportErrorMessage.value = "The request to get the export progress failed. Please check back later.";
                        }
                        if (taskHasFailed.value) {
                            exportErrorMessage.value = "The history export request failed. Please try again later.";
                        }
                    }
                }
                catch (e) {
                    exportErrorMessage.value = "The request to get your history exports records failed. Please check back later.";
                }
            });
        }
        function onCreateExportRecord() {
            return __awaiter(this, void 0, void 0, function* () {
                isExportDialogOpen.value = true;
            });
        }
        function doExportToFileSource(exportDirectory, fileName) {
            return __awaiter(this, void 0, void 0, function* () {
                isExportingRecord.value = true;
                isExportDialogOpen.value = false;
                // Avoid name collisions if multiple different histories are exported to the
                // same destination with the same name
                const prefixedFileName = `${props.history.id}_${fileName}`;
                try {
                    yield exportToFileSource(props.history.id, exportDirectory, prefixedFileName, DEFAULT_EXPORT_PARAMS);
                }
                catch (error) {
                    exportErrorMessage.value = "The history export request failed. Please try again later.";
                }
                updateExports();
            });
        }
        function onArchiveHistoryWithExport() {
            if (mostUpToDateExport.value) {
                emit("onArchive", mostUpToDateExport.value.id);
            }
        }
        return { __sfc: true, isExportTaskRunning, waitForTask, taskMonitorRequestFailed, taskHasFailed, props, emit, existingExports, isLoading, isExportingRecord, isExportDialogOpen, isDeleteContentsConfirmed, exportErrorMessage, mostUpToDateExport, canCreateExportRecord, canArchiveHistory, mostUpToDateExportIsReady, updateExports, onCreateExportRecord, doExportToFileSource, onArchiveHistoryWithExport, BAlert, BButton, BFormCheckbox, BModal, LoadingSpan, ExportToFileSourceForm, ExportRecordCard };
    }
});
